import { useCallback, useContext, useMemo } from 'react'
import ApplicationContext from '../context/ApplicationContext'
import LocationUtilities from '../utilities/LocationUtilities'
import SearchLocationContext from '../context/SearchLocationContext'

const useFilters = () => {
    const [applicationData, setApplicationData] = useContext(ApplicationContext)
    const [searchLocationData, setSearchLocationData] = useContext(SearchLocationContext)
    const openFiltersList = useMemo(() => applicationData.openFiltersList, [applicationData.openFiltersList])
    const appliedFilters = useMemo(() => searchLocationData.appliedFilters, [searchLocationData.appliedFilters])

    const toggleFiltersList = useCallback(() => {
        setApplicationData(prevState => {
            return {
                ...prevState,
                openFiltersList: !prevState.openFiltersList,
                overlay: !prevState.overlay,
            }
        })
    }, [openFiltersList])

    const updateFilters = (filters, updateSearchResults) => {
        setSearchLocationData(prevState => {
            return {
                ...prevState,
                appliedFilters: filters,
            }
        })
        updateSearchResults && searchForLocations(filters)
    }

    const searchForLocations = filters => {
        setSearchLocationData(prevState => {
            return {
                ...prevState,
                locationList: [],
                locationsLoading: true,
                disableRoamingRequest: true,
            }
        })
        const searchBody = {
            ...LocationUtilities.generateSearchBody(searchLocationData),
            ...LocationUtilities.generateSearchFilters(filters || appliedFilters),
        }

        LocationUtilities.postSearchLocations(searchBody)
            .then(response => {
                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        locationList: response.data.data,
                        locationsLoading: false,
                    }
                })
            })
            .catch(() => {
                setSearchLocationData(prevState => {
                    return {
                        ...prevState,
                        locationsLoading: false,
                        error: true,
                    }
                })
            })
    }

    return {
        openFiltersList,
        toggleFiltersList,
        updateFilters,
        appliedFilters,
        searchForLocations,
    }
}

export { useFilters }
